import {ChangeDetectorRef, Component, DoCheck, Input, inject} from '@angular/core';
import {AbstractControl, ValidatorFn} from '@angular/forms';

@Component({
    selector: 'app-required',
    templateUrl: './required.component.html',
    styleUrls: ['./required.component.scss']
})
export class RequiredComponent implements DoCheck {

  @Input() control: AbstractControl;

  required: boolean;

  private changeRef = inject(ChangeDetectorRef);
  private defaultValidatorFn: ValidatorFn = () => ({});

  ngDoCheck(): void {
    const validatorFn: ValidatorFn = this.control?.validator ?? this.defaultValidatorFn;
    this.required = validatorFn({} as AbstractControl)?.required ?? false;
    this.changeRef.detectChanges();
  }

}
